module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.checkph,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), (_vm.phone.length > 0) ? _c('div', {
    staticClass: "clear",
    on: {
      "click": function($event) {
        _vm.phone = ""
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "row row1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    ref: "password",
    staticClass: "phone",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "clear"
  }, [(_vm.password.length > 0) ? _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.password = ""
      }
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })]) : _vm._e(), _c('span', [_vm._v("    ")]), _c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggletype
    }
  }, [(_vm.tpsw == true) ? _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-biyan"
    }
  }) : _c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-yanjing"
    }
  })])])])]), _c('div', {
    staticClass: "reset"
  }, [_c('router-link', {
    attrs: {
      "to": "/reset"
    }
  }, [_vm._v("忘记密码？")])], 1), _c('div', {
    staticClass: "confirm"
  }, [_vm._v("登录                                 ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3d419b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 120
// module chunks = 0